import { render } from "./CxKpiCard.vue?vue&type=template&id=1ba2f4a4"
import script from "./CxKpiCard.vue?vue&type=script&lang=js"
export * from "./CxKpiCard.vue?vue&type=script&lang=js"

import "./CxKpiCard.vue?vue&type=style&index=0&id=1ba2f4a4&lang=less"

import exportComponent from "/home/ec2-user/workspace/_conx-ui-monorepo_ui2_lab_master/apps/ui2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__